module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="t-o-c-notice">\n  <h2>购票须知</h2>\n\n  <ul>\n    <li>\n      <div>\n        <h3>取消条款</h3>\n        <div class=\'cancelRule\'>' +
((__t = (data.ticketPriceModel.clauseDescShow)) == null ? '' : __t) +
'</div>\n      </div>\n    </li>\n\n  </ul>\n  <div class="t-o-c-button">\n    <div>购买详情须知 ></div>\n  </div>\n  <div class="t-o-c-total">\n    <span>订单总金额：</span>\n    <span class="theTotalLogo">￥</span>\n    <span class="theTotalMoney"></span>\n    <span class="theTotalNums"></span>\n  </div>\n</div>\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/js/ticketOrderConfirm/templates/guestMessage.ejs
// module id = 57
// module chunks = 0 1 2 6 10 11 14